import { useState, useEffect } from 'react';
/** Components */
import Loader from 'components/Loader';
import ContractList from './ContractList';
/** Services */
import { getClientsContracts } from 'services/contracts';
/** Utils */
import { createToast } from 'utils/toast';
/** Styles */
import styles from './Contracts.module.scss';

const Contracts = () => {
  const [contractList, setContractList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getClientsContracts()
      .then(({ status, data: { clientContracts } }) => {
        if (status === 200) {
          setContractList(clientContracts);
        }
        setLoading(false);
      })
      .catch(({ status }) => {
        setLoading(false);
        if (status === 401) {
          createToast({
            text: 'No tienes suficientes permisos',
            type: 'error',
          });
          return;
        }
        if (status === 404) {
          createToast({
            text: 'No existen contratos de clientes',
            type: 'error',
          });
          return;
        }

        createToast({ text: 'Algo ha salido mal', type: 'error' });
      });
  }, []);

  const handleDeleteContract = (ids) => {
    setContractList(
      contractList.filter((contract) => !ids.includes(contract.id))
    );
  };

  return loading ? (
    <Loader />
  ) : (
    <div className={styles.Contracts}>
      <div className={styles.ContractsHeader}>
        <h1 className="title">Contratos de clientes</h1>
      </div>
      <div className={styles.ContractsList}>
        <ContractList
          contracts={contractList}
          reloadContracts={handleDeleteContract}
        />
      </div>
    </div>
  );
};

export default Contracts;
